import { checkInputValidity } from './checkInputValidity'
import { checkSelectValidity } from './checkSelectValidity'
import { hideInputError } from './hideInputError'
import { showInputError } from './showInputError'
import { showSelectError } from './showSelectError'
import { hideSelectError } from './hideSelectError'
import { STATES } from '../../../constants/states'

import { loadBirthdateIMask } from './loadBirthdateIMask'
import { loadPhoneIMask } from './loadPhoneIMask'
import { loadVerifiedPhoneIMask } from './loadVerifiedPhoneIMask'

export function setUpFormInputs() {
  const inputs = /** @type {HTMLInputElement[]} */ (
    Array.from(document.querySelectorAll('form input[name]') || [])
  )

  const selects = /** @type {HTMLSelectElement[]} */ (
    Array.from(document.querySelectorAll('form select[name]') || [])
  )

  inputs.forEach((input) => {
    if (input.name === 'phoneVerified') {
      loadVerifiedPhoneIMask(input)
    }

    if (input.name === 'phone') {
      loadPhoneIMask(input)
    }

    if (input.name == 'birthdate') {
      loadBirthdateIMask(input)
    }

    input.addEventListener('blur', (e) => {
      const target = /** @type {HTMLInputElement | null} */ (e.target)
      if (target) {
        if (target.required) {
          if (!checkInputValidity(target)) {
            showInputError(target)
          } else {
            hideInputError(target)
          }
        }
      }
    })
  })

  selects.forEach((select) => {
    select.addEventListener('blur', (e) => {
      const target = /** @type {HTMLSelectElement | null} */ (e.target)
      if (target && target.required) {
        if (!checkSelectValidity(target)) {
          showSelectError(target)
        } else {
          hideSelectError(target)
        }
      }
    })

    if (select.name === 'state') {
      STATES.forEach((state) => {
        const option = document.createElement('option')
        option.value = state.abbreviation
        option.textContent = select.hasAttribute('data-full-state')
          ? state.name
          : state.abbreviation
        select?.appendChild(option)
      })
    }
  })
}
